import type { PostHogConfig } from 'posthog-js/dist/module.slim';

/**
 * PostHog options that keep data out of telemetry, spread into `posthog.init`.
 *
 * - `save_campaign_params: false`. From 1.419, posthog-js derives Meta's advertising identifiers
 *   from campaign data: `$fbc` from an `fbclid` URL parameter or the `_fbc` pixel cookie, `$fbp`
 *   from the `_fbp` cookie. It sets them on the person and caches them as flag person properties
 *   before `before_send` runs, so they would also reach `/flags`. Campaign capture is the SDK's only
 *   switch for them. Production records no UTM or click-ID parameters, so nothing else is lost.
 * - `web_vitals_attribution: false`. From 1.419, web-vitals events attribute INP and LCP to the CSS
 *   selector of the element involved. Whether web vitals are captured at all stays with the project
 *   setting: the object leaves `web_vitals` and `network_timing` unset.
 */
export const POSTHOG_PRIVACY_CONFIG = {
    save_campaign_params: false,
    capture_performance: { web_vitals_attribution: false },
} as const satisfies Partial<PostHogConfig>;
